module.exports = __webpack_public_path__ + "media/images/pic/brodno/speaking_bg-139c40115b5991c0558e66d67c67b15f.png";